import { DynamicListTwoColumnsProps } from 'sly/hubPage/components/HubDynamicContent/DynamicListTwoColumns/DynamicListTwoColumns.types';

export default function DynamicListTwoColumns({
  listInTwoColumnsValue,
}: DynamicListTwoColumnsProps) {
  if (!listInTwoColumnsValue) {
    return null;
  }
  return (
    <div
      className='dynamic-list-two-columns w-[calc(100%-2rem)] md:w-[var(--col6)] md:p-xs lg:w-[var(--col8)]'
      dangerouslySetInnerHTML={{ __html: listInTwoColumnsValue }}
      data-tp-id='gen-div-8fa6b0e2-0ec4-4e95-a7cc-f77e1edd5068'
    />
  );
}
